<template>
  <v-container>
    <v-row>
      <v-col cols="12" align="center" justify="center">
        <h1>Coaching platform</h1>
        <h3>Company metrics</h3>
      </v-col>
    </v-row>
    <v-row v-if="$apollo.loading" align="center" justify="center">
      <v-col v-for="index in 12" :key="index" cols="12" md="4">
        <v-skeleton-loader type="card" />
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col v-for="(metric, index) in todayCompanyMetric" :key="index" cols="4" align="center" justify="center">
        <metric-card :label="metric.label" :cohort="metric.cohort" :total="metric.total" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { COMPANY_METRICS_QUERY } from "@/graphql/queries/reporting.js";
import MetricCard from "@/components/shared/MetricCard";

export default {
  name: "Home",
  components: {
    MetricCard,
  },
  data() {
    return {
      todayCompanyMetric: null,
    };
  },
  created() {
    // contractor goes straight to coaching dash
    if (this.$store.getters.isContractor) {
      this.$router.push({ name: "CoachingOneOnOneSubscription", params: { coachId: this.$store.getters.user.id } });
    }
  },
  apollo: {
    todayCompanyMetric: {
      query: COMPANY_METRICS_QUERY,
    },
  },
};
</script>
